export const adminColors = {
  primary: '#2C6CA0',
  primaryHover: '#1F557F',
  primarySoft: '#2C6CA014',
  text: '#222B45',
  textSoft: '#222B45CC',
  mutedText: '#4B5563',
  subtleText: '#808080',
  disabledText: '#9AA3AF',
  border: '#e0e0e0',
  borderHover: '#C8CEE3',
  divider: '#ECEEF3',
  surface: '#FFFFFF',
  surfaceAlt: '#F8F9FB',
  surfaceSubtle: '#F8FBFF',
  appBackground: '#fbfafe',
  tableHead: '#F6F7FA',
  fieldBackground: '#FFFFFF',
  info: '#2C6CA0',
  infoBackground: '#F8FBFF',
  success: '#137333',
  successBackground: '#E7F7ED',
  warning: '#9A6700',
  warningBackground: '#FFF7DB',
  danger: '#B42318',
  dangerHover: '#8E1B12',
  dangerBackground: '#FEE4E2',
  neutral: '#5F6B7A',
  neutralBackground: '#F3F4F6',
  focusRing: 'rgba(44, 108, 160, 0.16)',
} as const;

export const adminTypography = {
  pageTitle: { fontSize: '24px', fontWeight: 600, lineHeight: 1.2 },
  pageMeta: { fontSize: '13px', fontWeight: 400, lineHeight: 1.4 },
  sectionTitle: { fontSize: '16px', fontWeight: 600, lineHeight: 1.25 },
  cardTitle: { fontSize: '16px', fontWeight: 600, lineHeight: 1.25 },
  tableHeader: { fontSize: '12px', fontWeight: 600, lineHeight: 1.15 },
  body: { fontSize: '13px', fontWeight: 400, lineHeight: 1.4 },
  bodyStrong: { fontSize: '14px', fontWeight: 600, lineHeight: 1.2 },
  label: { fontSize: '13px', fontWeight: 500, lineHeight: 1.35 },
  helper: { fontSize: '13px', fontWeight: 400, lineHeight: 1.35 },
  pill: { fontSize: '13px', fontWeight: 600, lineHeight: 1.2 },
  button: { fontSize: '13px', fontWeight: 600, lineHeight: 1.2 },
} as const;

export const adminSpacing = {
  xxs: 0.25,
  xs: 0.5,
  sm: 1,
  md: 1.5,
  lg: 2,
  xl: 3,
  surfaceX: 2,
  surfaceY: 1.5,
} as const;

export const adminRadii = {
  sm: '6px',
  md: '8px',
} as const;

export const adminBorders = {
  surface: `1px solid ${adminColors.border}`,
  divider: `1px solid ${adminColors.divider}`,
  focus: `1px solid ${adminColors.primary}`,
  dashed: `1px dashed ${adminColors.border}`,
} as const;

export const adminShadows = {
  none: 'none',
  dialog: '0px 8px 24px rgba(34, 43, 69, 0.12)',
} as const;

export const adminControlHeights = {
  buttonSmall: 32,
  fieldSmall: 36,
  tableRowDense: 34,
  tablePagination: 40,
  pill: 24,
} as const;

export const adminLayout = {
  formLabelColumn: '170px',
  dialogMaxHeight: 'calc(100vh - 48px)',
  pageMaxWidth: '100%',
} as const;
